<template>
  <div>
    <transition name="slide-fade">
      <div class="loading-integreat" v-if="isLoadingPage">
        <div class="initial-load-animation">
          <div class="linkedin-image"></div>
          <div class="loading-bar">
            <div class="blue-bar"></div>
          </div>
        </div>
      </div>
    </transition>
    <div class="level is-margin-bottom-2 is-hidden-mobile">
      <div class="level-left">
        <p class="title is-4 is-spaced has-text-weight-normal label-Left">
          {{ $t("smartReport.smartReportCompany") }} ({{ companyList.length }}
          {{
            companyList.length > 1
              ? $t("message.companiesSuffix")
              : $t("message.companySuffix")
          }})
        </p>
      </div>
      <div class="level-right">
        <a
          @click="prevPage()"
          v-if="user.userLevel > 80"
          class="box-back-page is-flex is-align-center"
        >
          <p class="text-back-page backpage-color has-text-weight-semibold">
            <i class="fas fa-arrow-left is-margin-right-sm"></i
            >{{ $t("message.btnBackToAdmin") }}
          </p>
        </a>
        <a class="box-back-page is-flex is-align-center">
          <p class="text-back-page done-color has-text-weight-semibold">
            Last Active: {{ dateFomat(dateNow) }}
          </p>
        </a>
      </div>
    </div>
    <div class="columns m-h-auto mg-y-15">
      <div class="column is-offset-6 is-6">
        <div class="columns m-h-auto th mg-x-0">
          <div
            class="is-size-7 batchStartDate is-flex is-align-center is-justify-center"
          >
            {{ $t("smartReport.operationPeriod") }}
          </div>
          <div class="column">
            <b-field>
              <b-datepicker
                v-model="rangeStartDate"
                placeholder="All"
                icon="calendar-alt"
                icon-pack="fas"
                :min-date="new Date('01-01-2015')"
                :date-formatter="(date) => dobFormatter(date)"
              >
              </b-datepicker>
            </b-field>
          </div>
          <div
            class="is-size-7 batchStartDate is-flex is-align-center is-justify-center"
          >
            {{ $t("smartReport.to") }}
          </div>
          <div class="column">
            <b-field>
              <b-datepicker
                position="is-bottom-left"
                v-model="rangeEndDate"
                placeholder="All"
                icon="calendar-alt"
                icon-pack="fas"
                :min-date="new Date(rangeStartDate)"
                :date-formatter="(date) => dobFormatter(date)"
              >
              </b-datepicker>
            </b-field>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-margin-x-not head-table is-hidden-mobile">
      <div
        class="column is-3 has-text-centered"
        @click="sortBy('organizeName')"
      >
        <p
          class="is-size-6 has-text-weight-semibold cr-pointer"
          :class="{ 'has-text-secondary': currentSort === 'organizeName' }"
        >
          {{ $t("smartReport.smartReportCompany") }}
          <span
            class="arrow"
            :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
            v-show="currentSort == 'organizeName'"
          ></span>
        </p>
      </div>
      <div class="column has-text-centered" @click="sortBy('typeOfIndustry')">
        <p
          class="is-size-6 has-text-weight-semibold cr-pointer"
          :class="{ 'has-text-secondary': currentSort === 'typeOfIndustry' }"
        >
          {{ $t("smartReport.smartReportBusinessType") }}
          <span
            class="arrow"
            :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
            v-show="currentSort == 'typeOfIndustry'"
          ></span>
        </p>
      </div>
      <div class="column has-text-centered" @click="sortBy('typeOfIndustry')">
        <p
          class="is-size-6 has-text-weight-semibold cr-pointer"
          :class="{ 'has-text-secondary': currentSort === 'typeOfIndustry' }"
        >
          {{ $t("smartReport.smartReportLevelBusiness") }}
          <span
            class="arrow"
            :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
            v-show="currentSort == 'typeOfIndustry'"
          ></span>
        </p>
      </div>
      <div class="column has-text-centered" @click="sortBy('dateUpdate')">
        <p
          class="is-size-6 has-text-weight-semibold cr-pointer"
          :class="{ 'has-text-secondary': currentSort === 'dateUpdate' }"
        >
          {{ $t("smartReport.smartReportLastUpdated") }}
          <span
            class="arrow"
            :class="currentSortDir === 'asc' ? 'asc' : 'dsc'"
            v-show="currentSort == 'dateUpdate'"
          ></span>
        </p>
      </div>
      <div
        class="column is-1 has-text-centered"
        @click="sortBy('organizeName')"
      ></div>
    </div>
    <div
      v-if="companyList == '' || companyList == null"
      class="is-detail-list detail-table mg-y-15"
    >
      <p class="has-text-drak is-size-4 th is-padding-x-s is-margin-top-s">
        ***
      </p>
      <p class="has-text-drak is-size-6 th is-padding-x has-text-centered">
        {{ $t("smartReport.notFound") }}
      </p>
      <p class="has-text-drak is-size-4 th is-padding-x-s is-margin-top-s">
        ***
      </p>
    </div>
    <div class="" v-else v-for="(data, index) in companyList" :key="data.id">
      <b-collapse
        :open="false"
        :aria-id="'contentIdForA11y' + index"
        class="detail-table is-block mg-b-35"
      >
        <div
          slot="trigger"
          slot-scope="props"
          role="button"
          :class="{
            active: props.open,
            'hover-border-board': getRule == 'board' ? true : false,
            'hover-border': getRule == 'exclusiveboard' ? true : false,
          }"
          class="columns is-margin-x-not is-vcentered m-h-auto box is-paddingless"
          :aria-controls="'contentIdForA11y' + index"
        >
          <div class="column is-3" data-label="organizeName">
            <div
              v-if="widthMax > 768"
              class="is-align-center is-justify-center is-flex-large is-flex-row"
            >
              <div class="column is-1"></div>
              <div
                class="column is-3 is-2-fullhd has-text-centered-tablet has-text-right"
              >
                <figure class="image box-circle-s is-marginless">
                  <img
                    class="is-rounded"
                    v-if="data.organizeLogo"
                    @error="
                      $event.target.src =
                        'https://bulma.io/images/placeholders/64x64.png'
                    "
                    :src="imgUrl + data.organizeLogo"
                  />
                  <img
                    class="is-rounded"
                    v-else
                    src="https://bulma.io/images/placeholders/64x64.png"
                    alt="Placeholder image"
                  />
                </figure>
              </div>
              <div class="column has-text-left is-hidden-mobile">
                <p class="has-text-dark is-size-7 has-text-weight-normal th">
                  {{ data.organizeName }}
                </p>
                <p class="is-size-7 has-text-weight-normal th">
                  {{ data.name }} {{ data.surname }}
                </p>
                <div
                  v-if="filterStatusActive(data.batchs) === 1"
                  class="textIconCompanyBox has-text-left"
                >
                  <b-icon
                    pack="fas"
                    icon="sync-alt"
                    custom-class="fa-circle"
                    class="has-text-success"
                  ></b-icon>
                  <p
                    class="textCompanyStatus has-text-dark is-size-7 has-text-weight-semibold"
                  >
                    {{ $t("message.statusInprocess") }}
                  </p>
                </div>
                <div
                  v-if="filterStatusActive(data.batchs) === 2"
                  class="textIconCompanyBox has-text-left"
                >
                  <b-icon
                    pack="fas"
                    icon="sync-alt"
                    custom-class="fa-circle"
                    class="has-text-info"
                  ></b-icon>
                  <p
                    class="textCompanyStatus has-text-dark is-size-7 has-text-weight-semibold"
                  >
                    {{ $t("message.statusAchieved") }}
                  </p>
                </div>
                <div
                  v-if="filterStatusActive(data.batchs) === 4"
                  class="textIconCompanyBox has-text-left"
                >
                  <b-icon
                    pack="fas"
                    icon="sync-alt"
                    custom-class="fa-circle"
                    class="text-batch"
                  ></b-icon>
                  <p
                    class="textCompanyStatus has-text-dark is-size-7 has-text-weight-semibold"
                  >
                    {{ $t("message.statusSucceed") }}
                  </p>
                </div>
                <div
                  v-if="filterStatusActive(data.batchs) === 3"
                  class="textIconCompanyBox has-text-left"
                >
                  <b-icon
                    pack="fas"
                    icon="sync-alt"
                    custom-class="fa-circle"
                    class="has-text-grey-light"
                  ></b-icon>
                  <p
                    class="textCompanyStatus has-text-dark is-size-7 has-text-weight-semibold"
                  >
                    {{ $t("message.statusDeactive") }}
                  </p>
                </div>
                <div
                  v-if="filterStatusActive(data.batchs) === 0"
                  class="textIconCompanyBox has-text-left"
                >
                  <b-icon
                    pack="fas"
                    icon="sync-alt"
                    custom-class="fa-circle"
                    class="has-text-grey-light"
                  ></b-icon>
                  <p
                    class="textCompanyStatus has-text-dark is-size-7 has-text-weight-semibold"
                  >
                    {{ $t("message.statusInactive") }}
                  </p>
                </div>
              </div>
            </div>
            <div
              v-if="widthMax < 768"
              class="is-align-center is-justify-center is-flex is-flex-column"
            >
              <div class="column is-6 has-text-centered pd-col-fixed">
                <figure class="image box-circle-s">
                  <img
                    class="is-rounded"
                    v-if="data.organizeLogo"
                    @error="
                      $event.target.src =
                        'https://bulma.io/images/placeholders/64x64.png'
                    "
                    :src="imgUrl + data.organizeLogo"
                  />
                  <img
                    class="is-rounded"
                    v-else
                    src="https://bulma.io/images/placeholders/64x64.png"
                    alt="Placeholder image"
                  />
                </figure>
              </div>
              <div class="column is-6 has-text-centered pd-col-fixed">
                <p class="has-text-dark is-size-7 has-text-weight-normal th">
                  {{ data.organizeName }}
                </p>
                <p class="is-size-7 has-text-weight-normal th">
                  {{ data.name }}
                </p>
              </div>
            </div>
          </div>

          <div class="column has-text-centered" data-label="typeOfIndustry">
            <p class="is-size-6 th">
              {{ getBusinessTypeName(data.typeOfBusiness) }}
            </p>
          </div>
          <div class="column has-text-centered" data-label="typeOfIndustry">
            <p class="is-size-6 th">
              {{ getBusinessLevelName(data.levelOfbusiness) }}
            </p>
          </div>
          <div class="column has-text-centered" data-label="dateUpdate">
            <div class="column has-text-centered">
              <p class="is-size-6 has-text-weight-normal">
                {{ dateFomat(data.lastLogin) }}
              </p>
            </div>
            <div
              class="is-flex is-justify-spacebetween is-align-center is-hidden-tablet pd-20"
            >
              <div class="has-text-left">
                <p class="is-size-7 has-text-weight-normal"></p>
              </div>
              <div class="has-text-right">
                <div
                  v-if="data.statusActive == 1"
                  class="textIconCompanyBox has-text-right"
                >
                  <b-icon
                    pack="fas"
                    icon="sync-alt"
                    custom-class="fa-circle"
                    class="has-text-success"
                  ></b-icon>
                  <p
                    class="textCompanyStatus has-text-dark is-size-7 has-text-weight-semibold"
                  >
                    {{ $t("message.statusInprocess") }}
                  </p>
                </div>
                <div
                  v-if="data.statusActive == 2"
                  class="textIconCompanyBox has-text-right"
                >
                  <b-icon
                    pack="fas"
                    icon="sync-alt"
                    custom-class="fa-circle"
                    class="has-text-info"
                  ></b-icon>
                  <p
                    class="textCompanyStatus has-text-dark is-size-7 has-text-weight-semibold"
                  >
                    {{ $t("message.statusInprocess") }}
                  </p>
                </div>
                <div
                  v-if="data.statusActive == 4"
                  class="textIconCompanyBox has-text-left"
                >
                  <b-icon
                    pack="fas"
                    icon="sync-alt"
                    custom-class="fa-circle"
                    class="text-batch"
                  ></b-icon>
                  <p
                    class="textCompanyStatus has-text-dark is-size-7 has-text-weight-semibold"
                  >
                    {{ $t("message.statusAchieved") }}
                  </p>
                </div>
                <div
                  v-if="data.statusActive == 3"
                  class="textIconCompanyBox has-text-right"
                >
                  <b-icon
                    pack="fas"
                    icon="sync-alt"
                    custom-class="fa-circle"
                    class="has-text-grey-light"
                  ></b-icon>
                  <p
                    class="textCompanyStatus has-text-dark is-size-7 has-text-weight-semibold"
                  >
                    {{ $t("message.statusSucceed") }}
                  </p>
                </div>
                <div
                  v-if="data.statusActive == 0"
                  class="textIconCompanyBox has-text-right"
                >
                  <b-icon
                    pack="fas"
                    icon="sync-alt"
                    custom-class="fa-circle"
                    class="has-text-grey-light"
                  ></b-icon>
                  <p
                    class="textCompanyStatus has-text-dark is-size-7 has-text-weight-semibold"
                  >
                    {{ $t("message.statusDeactive") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-1 is-flex is-justify-center">
            <div class="">
              <span @click="viewReport(data.companyId)" class="icon is-large">
                <i class="fas fa-3x fa-eye"></i>
              </span>
            </div>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>
<script>
import momentTH from "moment/src/locale/th";
import moment from "moment";
import { HTTP } from "../axios.js";

export default {
  data() {
    return {
      searchEmail: "",
      searchTel: "",
      searchLastName: "",
      dateNow: new Date(),
      searchName: "",
      staffLists: [],
      imgUrl: process.env.VUE_APP_IMAGE_URL,
      currentSort: "",
      currentSortDir: "desc",
      widthMax: window.innerWidth,
      companyList: [],
      rangeEndDate: null,
      rangeStartDate: null,
      searchCompany: null,
      searchTypeBusiness: null,
      searchLevelBusiness: null,
      searchlastLogin: null,
      isLoadingPage: null,
    };
  },
  created() {
    this.isLoadingPage = null;
    this.fetchData();
    this.rangeEndDate =
      this.reportId.rangeEndDate != ""
        ? new Date(this.reportId.rangeEndDate)
        : new Date();
    this.rangeStartDate =
      this.reportId.rangeStartDate != ""
        ? new Date(this.reportId.rangeStartDate)
        : typeof this.batch.batchStartDate != "undefined"
        ? new Date(this.batch.batchStartDate)
        : new Date();
  },
  mounted() {
    this.isLoadingPage = true;
  },
  methods: {
    filterStatusActive(data) {
      let filter = data.filter((item) => item.batchId === this.batch._id);

      if (filter.length > 0) {
        return filter[0].statusActive;
      } else {
        return 0;
      }
    },
    dobFormatter(date) {
      const options = { year: "numeric", month: "numeric", day: "numeric" };
      return date.toLocaleDateString("en-GB", options);
    },
    startBatchDate(batchDate) {
      //console.log('aaaa',batchDate)
      let res = "";
      if (
        typeof batchDate === "undefined" ||
        batchDate === null ||
        batchDate === ""
      ) {
        res = "";
      } else {
        res = moment(
          moment(batchDate).locale("th", momentTH).add(543, "y")
        ).format("DD MMMM Y ");
      }
      return res;
    },
    getCategoryName(id) {
      let data = this.levelTypes.filter((search) => {
        return search.id == id;
      });
      return this.$i18n.locale === "th" ? data[0].name : data[0].nameEN;
    },
    getBusinessLevelName(id) {
      let data = this.businessLevel.filter((search) => {
        return search.id == id;
      });
      if (data.length > 0) {
        return this.$i18n.locale === "th" ? data[0].name : data[0].nameEN;
      } else {
        return "";
      }
    },
    getBusinessTypeName(id) {
      let data = this.businessType.filter((search) => {
        return search.id == id;
      });
      if (data.length > 0) {
        return this.$i18n.locale === "th" ? data[0].name : data[0].nameEN;
      } else {
        return "";
      }
    },
    prevPage() {
      this.$router.push("/report-admin-list");
    },
    viewReport(companyId) {
      //console.log(companyId)
      if (
        this.rangeStartDate == "" ||
        this.rangeEndDate == "" ||
        typeof this.rangeStartDate == "undefined" ||
        typeof this.rangeEndDate == "undefined" ||
        this.rangeStartDate == null ||
        this.rangeEndDate == null
      ) {
        this.$buefy.dialog.alert(
          "กรุณาเลือกระยะเวลาดำเนินงาน เพื่อแสดงใน Smart report"
        );
      } else {
        let arrData = [
          { key: "isCheckLock", value: false },
          { key: "companyId", value: companyId },
          { key: "batchId", value: this.batch._id },
          { key: "roleId", value: this.batch._id },
          { key: "rangeStartDate", value: this.rangeStartDate },
          { key: "rangeEndDate", value: this.rangeEndDate },
        ];

        arrData.map((item) => {
          this.$store.commit("setReportId", item);
          //console.log(item)
        });
        if (this.user.userLevel > 80) {
          let batchId = {
            _id: batch.batchId,
            levelType: batch.levelType,
          };
          this.$store.commit("setDataBatch", batchId);
        }

        if (this.getRule === "staff") {
          let under = { key: "underId", value: this.batch.underId };
          let scienceParkName = {
            key: "scienceParkName",
            value: this.batch.scienceParkName,
          };
          this.$store.commit("setReportId", under);
        }
        this.$router.push("/view-report");
      }
    },
    fetchData() {
      let data;
      let url;
      if (this.getRule == "admin") {
        // console.log('1')
        data = {
          adminId: this.user._id,
          batchId: this.batch._id,
        };
        url = "/api/admin/get/all/company/in/batch";
      } else if (this.getRule === "staff") {
        //console.log('2')
        data = {};
        url = "/api/smart/report/staff/get/company";
      } else {
        //console.log('3')
        data = {
          adminId: this.reportId.adminId,
        };
        url = "/api/board/get/all/company/in/admin";
      }
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(url, data)
        .then((res) => {
          //console.log('api/smart/report/staff/get/company',url,data,res)
          if (res.data.success) {
            this.isLoadingPage = false;
            let batch = [];
            res.data.obj.map((result) => {
              if (result.batchs.length > 0) {
                result.batchs.map((value) => {
                  if (
                    value.batchId == this.batch._id &&
                    value.statusActive != 0
                  ) {
                    batch.push(result);
                  }
                });
              }
            });

            this.companyList = batch.sort((a, b) => {
              let modifier = -1;
              if (a.lastLogin < b.lastLogin) return -1 * modifier;
              if (a.lastLogin > b.lastLogin) return 1 * modifier;
              return 0;
            });
            this.companyListAll = this.companyList;
            //console.log('qwdasd',batch)
          }
        })
        .catch((e) => {
          console.log(url, "/error", e);
        });
    },
    dateFomat(date) {
      let res = "";
      if (typeof date === "undefined" || date === null || date === "") {
        res = "";
      } else {
        res = this.$moment(date).format("DD MMMM Y");
      }
      return res;
    },
    resetFilter() {
      this.companyList = this.companyListAll;
      this.searchCompany = null;
      this.searchTypeBusiness = null;
      this.searchLevelBusiness = null;
      this.searchlastLogin = null;
    },
    filter() {
      var filter = this.companyListAll.filter(
        (search) =>
          ((this.searchCompany !== null &&
            (search.name
              .toLowerCase()
              .indexOf(this.searchCompany.toLowerCase()) > -1 ||
              search.organizeName
                .toLowerCase()
                .indexOf(this.searchCompany.toLowerCase()) > -1)) ||
            this.searchCompany === null) &&
          ((search.typeOfBusiness === Number(this.searchTypeBusiness) &&
            this.searchTypeBusiness !== null) ||
            this.searchTypeBusiness === null) &&
          ((this.levelOfbusiness !== null &&
            Number(search.levelOfbusiness) ===
              Number(this.searchLevelBusiness)) ||
            this.searchLevelBusiness === null) &&
          ((this.searchlastLogin !== null &&
            new Date(search.lastLogin).getTime() ===
              new Date(this.searchlastLogin).getTime()) ||
            this.searchlastLogin === null)
      );
      //	console.log(new Date(this.searchlastLogin).getTime(),new Date(this.companyListAll[0].lastLogin).getTime())
      this.companyList = filter;

      if (typeof this.$refs.dropdowntablet !== "undefined") {
        this.$refs.dropdowntablet.isActive = false;
      }
    },
  },
  computed: {
    levelTypes() {
      return this.$store.state.levelType;
    },
    businessLevel() {
      let res = [];
      if (this.batch.levelType === 1) {
        res = this.$store.state.projectLevel;
      } else if (this.batch.levelType === 2) {
        res = this.$store.state.businessLevel;
      } else {
        res = this.$store.state.technologyLevel;
      }
      return res;
    },
    businessType() {
      return this.$store.state.businessType;
    },
    reportId() {
      return this.$store.state.report;
    },
    user() {
      return this.$store.state.user;
    },
    batch() {
      return this.$store.state.batch;
    },
    token() {
      return this.$store.state.token;
    },
    getRule() {
      return this.$store.state.rule;
    },
  },
};
</script>
<style scoped>
.border-radius {
  display: flex;
  border-radius: 50%;
  align-items: center;
  width: 28px;
  justify-content: center;
  /* height: 28px; */
  color: #e1e1e1;
  border: 2px solid #e1e1e1;
}
.border-radius.active {
  background-color: #02a8a0;
  border: 1px solid #02a8a0;
  color: #fff;
}
.border-radius.active .icon {
  color: #fff;
}
</style>